module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_macarrão.14a756f4.png";